import { Outlet } from "react-router";

import AdminBarHeadsup from "~/components/AdminBarHeadsup";
import AuthRedirection from "~/components/AuthRedirection";
import ErrorBoundary from "~/components/ErrorBoundary";
import SessionProvider from "~/providers/SessionProvider";

const LayoutProviderWrapped = () => {
  return (
    <SessionProvider>
      <AdminBarHeadsup />
      <ErrorBoundary boundaryName="ProviderWrapped" fallbackMode="detailed">
        <Outlet />
      </ErrorBoundary>
      <AuthRedirection />
    </SessionProvider>
  );
};

export default LayoutProviderWrapped;
